import { Horizontal } from '@gravitate-js/excalibrr'

import { useLaunchpadContext } from '../context'
import { MetricCard } from './InvoiceMetricsCard'

/**
 * Component that displays invoice metrics for blocked invoices and credit/rebills
 */
export function InvoiceMetrics() {
  const { data } = useLaunchpadContext()

  if (!data) {
    return null
  }

  const { blocked, creditRebills } = data.invoiceMetrics

  return (
    <Horizontal flex='0' style={{ overflow: 'visible' }} gap={8}>
      <MetricCard
        title='Blocked Invoices MTD'
        value={blocked.count}
        trend={blocked.trend}
        trendDown={blocked.trendDirection === 'down'}
        trendUp={blocked.trendDirection === 'up'}
        count={blocked.count}
        countLabel='Invoices Blocked'
        goodLabel='No invoices are blocked from sending.'
        oldest={blocked.oldestTime}
        oldestLabel='TIME TO ACTION:'
        cardStyle='error'
      />
      <MetricCard
        title='Credit / Rebills MTD'
        value={creditRebills.count}
        trend={creditRebills.trend}
        trendDown={creditRebills.trendDirection === 'down'}
        trendUp={creditRebills.trendDirection === 'up'}
        count={creditRebills.openForApproval}
        countLabel='Open For Approval'
        oldest={creditRebills.oldestTime}
        goodLabel='All Credit Rebill requests have been approved.'
        cardStyle='warning'
      />
    </Horizontal>
  )
}
